import { createFileRoute } from '@tanstack/react-router'
import { PublicStatusScreen } from '@/screens/help/SCR-178-179-status'

// SCR-179 ESM status, public (help area). Works signed out.
export const Route = createFileRoute('/_public/status')({
  component: PublicStatusScreen,
})
